import type { Messages } from '../types';

export const trialBanner = {
  title:
    '{daysLeft, plural, =0 {Percubaan percuma anda tamat hari ini} other {{daysLeft} hari lagi dalam percubaan percuma anda}}',
  body: 'Pilih pelan supaya anak anda kekal akses penuh.',
  choosePlan: 'Pilih pelan',
  dismiss: 'Tutup',
  notifEndsOn: 'Tamat {date}. Ketik untuk pilih pelan.',
  notifEndsToday: 'Tamat hari ini.',
} as const satisfies Messages['trialBanner'];
